import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { formatCustomerName } from "~/lib/helpers";

const TOTE_SETUP_NOTES_MAX_LINES = 2;

type ToteBoxProps = {
  matchingPickFirstName: string;
  matchingPickLastName: string;
  externalToteId: string | undefined;
  toteSize: string | undefined;
  showCustomerName: boolean;
  setupNotes?: string;
  /* Background color can vary, so overriding the text color is needed sometimes. */
  textColor?: string;
};

function ToteBox(props: ToteBoxProps) {
  const { t } = useTranslation();
  const {
    matchingPickFirstName,
    matchingPickLastName,
    externalToteId,
    toteSize,
    showCustomerName,
    setupNotes,
    textColor
  } = props;

  return (
    <Box
      style={{
        marginTop:
          showCustomerName &&
          `${matchingPickFirstName} ${matchingPickLastName}`.length < 21
            ? "25px"
            : "4px"
      }}
    >
      {showCustomerName && (
        <Box sx={{ fontSize: "0.7em" }}>
          <Typography sx={{ fontSize: "1.4em" }}>
            {matchingPickFirstName && matchingPickLastName
              ? formatCustomerName(
                  `${matchingPickFirstName} ${matchingPickLastName}`
                )
              : t("customer name")}
          </Typography>
        </Box>
      )}

      {!showCustomerName && setupNotes && (
        <Box sx={{ mx: 2 }}>
          <Typography
            sx={{
              fontSize: "1.4em",
              display: "-webkit-box",
              WebkitLineClamp: TOTE_SETUP_NOTES_MAX_LINES,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              wordBreak: "break-word",
              color: textColor ?? "text.secondary"
            }}
          >
            {setupNotes}
          </Typography>
        </Box>
      )}

      {(externalToteId || toteSize) && (
        <Box
          sx={{
            marginTop:
              matchingPickFirstName &&
              matchingPickLastName &&
              `${matchingPickFirstName} ${matchingPickLastName}`.length < 25
                ? undefined
                : "1vH"
          }}
        >
          <Grid container justifyContent="space-between">
            {externalToteId && (
              <Grid item sx={{ fontSize: "0.825em", fontWeight: 600 }}>
                <Typography sx={{ fontSize: "1.4em" }}>
                  {externalToteId}
                </Typography>
              </Grid>
            )}
            {toteSize && (
              <Grid item sx={{ fontSize: "0.825em", fontWeight: 600 }}>
                <Typography sx={{ fontSize: "1.4em" }}>{toteSize}</Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </Box>
  );
}

export default ToteBox;
